import type { FC } from "react";
import React, { memo } from "react";

import {
    MIN_WIDTH_SVG_ELEMENT,
    PRICE_SVG_MASK_DISPLAY_NAME,
    PRICE_SVG_MASK_TEST_ID,
} from "../../vars";

import type { PropsWithTsId } from "../../../../types/react";

import classes from "./PriceSVGMask.styl";

interface ISVGMaskProps extends PropsWithTsId {
    width: number;
    id: string;
}

const PriceSVGMask: FC<ISVGMaskProps> = memo(
    ({ width: propWidth, id, "data-tsid": tsid }): JSX.Element => {
        const width = Math.max(propWidth, MIN_WIDTH_SVG_ELEMENT);

        const svgPath = `M0 11.9994V12.0006C0.000157048 12.8056 0.32187 13.6106 0.965138 14.2044 L10.1404 22.674 C11.064 23.5266 12.2748 24 13.5318 24 H15H${width} V0 H15 H13.5318 C12.2748 0 11.064 0.473429 10.1404 1.32601L0.96514 9.79561C0.321871 10.3894 0.000157048 11.1944 0 11.9994Z M12.9775 12C12.9775 13.1046 12.0821 14 10.9775 14C9.87297 14 8.97754 13.1046 8.97754 12C8.97754 10.8954 9.87297 10 10.9775 10C12.0821 10 12.9775 10.8954 12.9775 12Z `;

        return (
            <svg
                width={width}
                height="24"
                viewBox={`0 0 ${width} 24`}
                fill="none"
                className={classes["svg-mask"]}
                aria-hidden="true"
                data-tsid={tsid || PRICE_SVG_MASK_TEST_ID}
            >
                <clipPath id={id}>
                    <path d={svgPath} />
                </clipPath>
            </svg>
        );
    },
);

PriceSVGMask.displayName = PRICE_SVG_MASK_DISPLAY_NAME;

export default PriceSVGMask;
